"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = void 0;
var polished_1 = require("polished");
var styled_components_1 = __importDefault(require("styled-components"));
exports.Content = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  /* height: 100vh; */\n  margin-top: ", ";\n  margin-bottom: ", ";\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  @media (max-width: 650px) {\n    margin-top: 0;\n  }\n"], ["\n  width: 100%;\n  /* height: 100vh; */\n  margin-top: ", ";\n  margin-bottom: ", ";\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  @media (max-width: 650px) {\n    margin-top: 0;\n  }\n"])), (0, polished_1.rem)(100), (0, polished_1.rem)(100));
var templateObject_1;
